import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import useId from "hooks/useId";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {connect} from "react-redux";
import DealingsService from "services/DealingsService";
import isResponseValid from "libs/isResponseValid";
import RealizationAmountForm from "components/complex/realizationAmount/RealizationAmountForm";


const FinalRealizationValuePopup = (
    {
        demandId,
        onCancel,
        onSuccess,
        editable,
        formSubmit,
    }) => {


    const [realizationValues, setRealizationValues] = useState(null);
    const [working, setWorking] = useState(true);
    const [error, setError] = useState(null);
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = ({dealings}) => {
        setError(false);
        setWorking(true);

        const toCompare = realizationValues.dealings;

        const touched = dealings.filter((el, i) => {
            return el.realizationGrossValue !== toCompare[i].realizationGrossValue || el.realizationGrossOptionValue !== toCompare[i].realizationGrossOptionValue
        });

        DealingsService.saveFinalRealizationValues(demandId, {dealings: touched}).then(onSuccess).catch(() => {
            setError(Tr('unknown_error_message'));
            setWorking(false);
        });
    }

    useEffect(() => {
        DealingsService.getFinalRealizationValues(demandId).then(resp => {
            if (isResponseValid(resp, setError))
                setRealizationValues(resp)
        }).finally(() => setWorking(false))
    }, [demandId])

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel, 'outlined', working));
        buttons.push(createButton(Tr('realization_value_update'), handleSubmit, undefined, working || !editable));
        return buttons;
    }


    return (
        <Dialog
            open
            dialogActions={<MultiButton buttons={getButtons()}/>}
            title={Tr('final_realization_value')}
            maxWidth='md'
        >
            <GridBlock
                column
            >
                {working && <Loading/>}
                {!!error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{error}</TypographyWithIcon>}
                {!!realizationValues && <RealizationAmountForm
                    onSubmit={onSubmit}
                    required
                    formId={formId}
                    realizationValues={realizationValues}
                    editable={editable}
                />}
            </GridBlock>


        </Dialog>)
}

FinalRealizationValuePopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    editable: PropTypes.bool.isRequired,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(FinalRealizationValuePopup)